/**
 * @file index.tsx
 *
 * @fileoverview Renders a footer block with menus and content.
 */

import { ReactNode } from "react";
import Grid from "../../../02-atoms/06-layout/04-grid";
import Cell from "../../../02-atoms/06-layout/04-grid/01-cell";
import Spacing from "../../../02-atoms/06-layout/07-spacing";
import Main from "../../../02-atoms/06-layout/09-main";
import Box from "../../../02-atoms/07-box";
import styles from "./footer.module.scss";

export interface FooterProps {
  /**
   * The primary menu content aka. the menus.
   */
  children: ReactNode;
  /**
   * The logo to be shown in the footer.
   */
  logo?: ReactNode;
  /**
   * The logo to be shown in the footer.
   */
  socialLinks?: ReactNode;
  /**
   * The logo to be shown in the footer.
   */
  poweredBy?: ReactNode;
}

export const Footer = ({
  children,
  logo,
  socialLinks,
  poweredBy,
}: FooterProps) => {
  return (
    <footer>
      <Box className={styles.footerBox}>
        <Main size="unset">
          {children}
          <Spacing size="large" />
        </Main>
      </Box>
      <Box className={styles.footerSecondaryBox}>
        <Main size="unset">
          <Grid
            justifyItems={["normal", "center"]}
            alignItems={["normal", "center"]}
            columns={[1, 3]}
          >
            <Cell>{logo && <div className="footer-logo">{logo}</div>}</Cell>
            <Cell>{socialLinks && socialLinks}</Cell>
            <Cell>{poweredBy && poweredBy}</Cell>
          </Grid>
        </Main>
      </Box>
    </footer>
  );
};
